import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6ee069e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-bar-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-progress-bar" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  props: {
    progress: null
  },
  setup(__props: any) {

const props = __props as {
  progress: number
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "progress-bar",
      style: _normalizeStyle(`width: ${props.progress}%`)
    }, null, 4)
  ]))
}
}

})